<template>
  <div>
    <div class="carousel">
      <div class="carousel-content">
        <div
          class="carousel-item"
          v-for="(image, index) in images"
          :key="index"
        >
          <img :src="image" alt="Image" />
          <div class="bottom-text">
            <div class="text1">他们成就了我们</div>
            <div class="text1">我们为他们创造价值</div>
            <div class="text2">
              They have achieved us We create value for them
            </div>
          </div>
        </div>
      </div>
    </div>
	<div class="indicators">
		<div v-for="(image, index) in images" :key="index" :class="{ Select: currentIndex === index }" class="indicator">
    </div>
	  </div>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      images: [
        require("../../assets/jclb1.png"),
        require("../../assets/jclb2.png"),
        require("../../assets/jclb3.png"),
        require("../../assets/jclb4.png"),
      ],
      currentIndex: 0,
      timer:null
    };
  },
  mounted() {
    this.cloneItems();
    this.startAutoSlide();
  },
  beforeDestroy(){

    clearInterval(this.timer)
    this.timer=null
  },
  methods: {
    cloneItems() {
      const carouselContent = this.$el.querySelector(".carousel-content");
      const items = Array.from(carouselContent.children);
      const originalWidth = carouselContent.offsetWidth;
      items.forEach((item) => {
        const clone = item.cloneNode(true);
        carouselContent.appendChild(clone);
      });
      carouselContent.style.width = `${originalWidth * 2}px`;
    },
    startAutoSlide() {
      this.timer=setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.images.length;
      }, 15000); // Adjust the duration as needed
    },
  },
};
</script>
  
  <style scoped>
body {
  background: #eee;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #000;
  margin: 0;
  padding: 0;
  overflow: hidden; /* 防止页面出现滚动条 */
}

.carousel {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.carousel-content {
  display: flex;
  width: 200%; /* 设置为内容宽度的两倍，用于循环播放 */
  animation: scroll-left 60s linear infinite; /* 20秒滚动一次，线性匀速，无限循环 */
  
}

.carousel-item {
  flex: 1;
  min-width: calc(25% - 10px); /* 每个图片宽度占比 */
  box-sizing: border-box;
  background-color: #ececec;
  border-radius: 20px;
  margin-right: 10px;
}
.bottom-text {
  width: 100%;
  object-fit: contain;
}
.bottom-text .text1 {
  text-align: start;
  padding-left: 10px;
  margin-top: 5px;
  font-weight: 600;
}
.bottom-text .text2 {
  font-size: 13px;
  text-align: start;
  padding-left: 20px;
  margin-top: 5px;
  margin-bottom: 15px;
  font-weight: 600;
  position: relative;
}
.carousel-item img {
  width: 100%;
  display: block;
}

@keyframes scroll-left {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(-100%, 0, 0);
  }
}

.indicators {
 margin-top: 10px;
  display: flex;
  justify-content: center;
  
}

.indicator {
  width: 10px;
  height: 6px;
  background-color: #ccc;
  border-radius: 10px;
  margin: 0 5px;
  transition: background-color 0.3s ease;

}

.Select {
		height: 10px;
		width: 10px;
		border-radius: 10px;
		margin-left: 10px;
		animation: Select 15s linear 1 forwards;
		background-color: #9d1d1e;
	}
	@keyframes Select {
		from {
			height: 6px;
			width: 10px;
		}

		to {
			height: 6px;
			width: 50px;
		}
	}

</style>
  


// WEBPACK FOOTER //
// src/components/iphone/test.vue